<template>
  <v-list-item dense>
    <v-list-item-content>
      <v-list-item-title>
        <v-checkbox
          :value="category.id"
          :true-value="category.id"
          :label="category.name"
        />
      </v-list-item-title>
    </v-list-item-content>
    <template v-if="category.children != null">
      <structured-list
        v-for="(child, id) in category.children"
        :key="id"
        :category="child"
      />
    </template>
  </v-list-item>
</template>

<script>
  import StructuredList from '@/views/dashboard/components/parts/StructuredList'

  export default {
    name: 'StructuredList',
    components: {
      // eslint-disable-next-line vue/no-unused-components
      StructuredList,
    },
    props: {
      category: {
        type: Object,
        required: true,
      },
    },
    methods: {
      log (l) {
        console.log(l)
      },
    },
  }
</script>

<style>

</style>
